/* eslint-disable react/prop-types */
/* eslint-disable camelcase */
import AdjustIsolatedMarginModal from "../ConfirmationModal/AdjustIsolatedMarginModal";
import ClosePositionModal from "../ConfirmationModal/ClosePositionModal";
import TPSLForPositionModal from "../ConfirmationModal/TPSLForPositionModal";
import { PnLCardModal } from "../PnLCardModal";
import PositionDetailsModal from "../shared/ViewDetailsModal/PositionDetailsModal";
import { IModifiedPosition } from "./model";

interface IPositionModalsProps {
  positionById: (positionId?: string) => IModifiedPosition | undefined;
  adjustingMarginPositionId?: string;
  onAdjustMarginModalHide: () => void;
  showClosePositionModal: boolean;
  closingPositionId?: string;
  onClosePositionModalHide: () => void;
  viewDetailsForPositionId?: string;
  onPositionDetailsModalHide: () => void;
  shareModalPositionId?: string;
  onSharePositionModalHide: () => void;
  tpslModalPositionId?: string;
  onTPSLForPositionModalHide: () => void;
}

function PositionModals({
  positionById,
  adjustingMarginPositionId,
  onAdjustMarginModalHide,
  showClosePositionModal,
  closingPositionId,
  onClosePositionModalHide,
  viewDetailsForPositionId,
  onPositionDetailsModalHide,
  shareModalPositionId,
  onSharePositionModalHide,
  tpslModalPositionId,
  onTPSLForPositionModalHide,
}: IPositionModalsProps) {
  return (
    <>
      {positionById(adjustingMarginPositionId) && (
        <AdjustIsolatedMarginModal
          position={positionById(adjustingMarginPositionId)}
          onHide={onAdjustMarginModalHide}
        />
      )}
      {showClosePositionModal && (
        <ClosePositionModal
          //@ts-ignore
          position={positionById(closingPositionId)}
          onHide={onClosePositionModalHide}
          show={showClosePositionModal}
        />
      )}
      {positionById(viewDetailsForPositionId) && (
        <PositionDetailsModal
          //@ts-ignore
          position={positionById(viewDetailsForPositionId)}
          onHide={onPositionDetailsModalHide}
        />
      )}
      {!!shareModalPositionId && (
        <PnLCardModal
          pnlType="position"
          //@ts-ignore
          pnlData={positionById(shareModalPositionId)}
          onHideModal={onSharePositionModalHide}
          show={!!shareModalPositionId}
          onHidePnLCard={onSharePositionModalHide}
          hideBackButton
        />
      )}
      {!!tpslModalPositionId && (
        <TPSLForPositionModal
          //@ts-ignore
          position={positionById(tpslModalPositionId)}
          onHide={onTPSLForPositionModalHide}
          show={!!tpslModalPositionId}
        />
      )}
    </>
  );
}

export default PositionModals;
